export const financialReportList = [
  {
    date: "30 September 2024",
    tag: "2024",
    title:
      "INTERIM FINANCIAL STATEMENTS FOR THE FINANCIAL QUARTER ENDED 30 SEPTEMBER 2024",
    description:
      "Al Rajhi Banking & Investment Corporation (Malaysia) Bhd (alrajhi bank Malaysia) ",
    link: "https://www.alrajhibank.com.my/assets/pdf/financial-reports/2024/quarter/ARBM_FS30Sept24_Q3.pdf",
  },
  {
    date: "30 June 2024",
    tag: "2024",
    title: "PILLAR 3 DISCLOSURE HALF END 2024",
    description:
      "Al Rajhi Banking & Investment Corporation (Malaysia) Bhd (alrajhi bank Malaysia) ",
    link: "https://www.alrajhibank.com.my/assets/pdf/financial-reports/2024/quarter/Pillar3Disclosure_June24.pdf",
  },
  {
    date: "31 March 2024",
    tag: "2024",
    title:
      "INTERIM FINANCIAL STATEMENTS FOR THE FINANCIAL QUARTER ENDED 31 MARCH 2024",
    description:
      "Al Rajhi Banking & Investment Corporation (Malaysia) Bhd (alrajhi bank Malaysia) ",
    link: "https://www.alrajhibank.com.my/assets/pdf/financial-reports/2024/quarter/ARBM_FS31Mar24_Q1.pdf",
  },
  {
    date: "30 June 2024",
    tag: "2024",
    title:
      "INTERIM FINANCIAL STATEMENTS FOR THE FINANCIAL QUARTER ENDED 30 JUNE 2024",
    description:
      "Al Rajhi Banking & Investment Corporation (Malaysia) Bhd (alrajhi bank Malaysia) ",
    link: "https://www.alrajhibank.com.my/assets/pdf/financial-reports/2024/quarter/ARBM_FS30June24_Q2.pdf",
  },
  {
    date: "31 December 2023",
    tag: "2023",
    title: "PILLAR 3 DISCLOSURE AS AT 31 DECEMBER 2023",
    description:
      "Al Rajhi Banking & Investment Corporation (Malaysia) Bhd (alrajhi bank Malaysia) ",
    link: "https://www.alrajhibank.com.my/assets/pdf/financial-reports/2023/annual/Pillar3_Disclosure_Dec2023.pdf",
  },
  {
    date: "31 December 2023",
    tag: "2023",
    title: "Financial Statements for the financial year ended 31 December 2023",
    description:
      "Al Rajhi Banking & Investment Corporation (Malaysia) Bhd (alrajhi bank Malaysia) ",
    link: "https://www.alrajhibank.com.my/assets/pdf/financial-reports/2023/annual/ARBM_Financial_Statements_FY2023.pdf",
  },
  {
    date: "30 June 2023",
    tag: "2023",
    title: "PILLAR 3 DISCLOSURE AS AT 30 JUNE 2023",
    description:
      "Al Rajhi Banking & Investment Corporation (Malaysia) Bhd (alrajhi bank Malaysia) ",
    link: "https://www.alrajhibank.com.my/assets/pdf/financial-reports/2023/quarter/Pillar3Disclosure_June23.pdf",
  },
  {
    date: "30 March 2023",
    tag: "2023",
    title:
      "INTERIM FINANCIAL STATEMENTS FOR THE FINANCIAL QUARTER ENDED 30 MARCH 2023",
    description:
      "Al Rajhi Banking & Investment Corporation (Malaysia) Bhd (alrajhi bank Malaysia) ",
    link: "https://www.alrajhibank.com.my/assets/pdf/financial-reports/2023/quarter/ARBM_FS31_Mar23Q1_Final.pdf",
  },
  {
    date: "30 September 2023",
    tag: "2023",
    title:
      "INTERIM FINANCIAL STATEMENTS FOR THE FINANCIAL QUARTER ENDED 30 SEPTEMBER 2023",
    description:
      "Al Rajhi Banking & Investment Corporation (Malaysia) Bhd (alrajhi bank Malaysia) ",
    link: "https://www.alrajhibank.com.my/assets/pdf/financial-reports/2023/quarter/ARBM_FS30_Sep23Q3_Final.pdf",
  },
  {
    date: "30 June 2023",
    tag: "2023",
    title:
      "INTERIM FINANCIAL STATEMENTS FOR THE FINANCIAL QUARTER ENDED 30 JUNE 2023",
    description:
      "Al Rajhi Banking & Investment Corporation (Malaysia) Bhd (alrajhi bank Malaysia) ",
    link: "https://www.alrajhibank.com.my/assets/pdf/financial-reports/2023/quarter/ARBM_FS30_June_23Q2.pdf",
  },
];
